import type { StripeCardTypes } from '@givebacks/api/core';
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';

type StripeElementCardBrands = StripeCardElementChangeEvent['brand'];

type Cards = {
  [key in StripeElementCardBrands]: StripeCardTypes;
};
const STRIPE_ELEMENT_CARD_BRANDS: Cards = {
  visa: 'Visa',
  mastercard: 'MasterCard',
  amex: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  unknown: 'Unknown',
};
const translateCardBrand = (brand: StripeElementCardBrands): StripeCardTypes => {
  return STRIPE_ELEMENT_CARD_BRANDS[brand];
};

export { translateCardBrand };
